import React from 'react';
import { Route, Routes, Navigate, useMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import CompanyProfile from './CompanyProfile';
import ProfileNavigation from './ProfileNavigation';
import CompanyEmployees from './CompanyEmployees';
// import Calculations from "./Calculations";
import ProfileDocuments from './ProfileDocuments';
import AddTransport from './AddTransport';
import PageContainer from '../../common/PageContainer';
import PageTitle from 'components/common/Layout/PageTitle';
import Park from './Park';
import { PROFILE_RELATIVE_ROUTES, PROFILE } from 'helpers/routes';

import './profileTable.scss';
import './profile.scss';

export default function Profile() {
  const { t } = useTranslation();
  const currentPage = t('profile.heading');
  // На вкладке «Профиль компании» заголовок и навигация живут внутри карточки (ProfileCardLayout),
  // поэтому внешние дублировать не нужно. Остальные вкладки (в том числе /company/edit) их используют.
  const isCompanyCard = Boolean(useMatch(PROFILE.profile));

  return (
    <PageContainer>
      {!isCompanyCard && (
        <>
          <PageTitle>{currentPage}</PageTitle>
          <ProfileNavigation />
        </>
      )}
      <Routes>
        <Route path={`${PROFILE_RELATIVE_ROUTES.profile}/*`} element={<CompanyProfile />} />
        <Route path={PROFILE_RELATIVE_ROUTES.employees} element={<CompanyEmployees />} />
        <Route path={PROFILE_RELATIVE_ROUTES.documents} element={<ProfileDocuments />} />
        {/* <Route path={PROFILE.calculations} element={<Calculations />} /> */}
        <Route path={PROFILE_RELATIVE_ROUTES.park} element={<Park />} />
        <Route path={PROFILE_RELATIVE_ROUTES.addTransport} element={<AddTransport />} />
        <Route path={PROFILE_RELATIVE_ROUTES.editTransport} element={<AddTransport />} />
        <Route path="*" element={<Navigate to={PROFILE.profile} replace />} />
      </Routes>
    </PageContainer>
  );
}
